module.exports = __webpack_public_path__ + "static/media/traffic-road.9ccfeaa8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/traffic-road.svg
// module id = 824
// module chunks = 0